__turbopack_context__.v({
  "copyright": "FooterContent-module__MxEYrG__copyright",
  "link": "FooterContent-module__MxEYrG__link",
  "list": "FooterContent-module__MxEYrG__list",
});
